<template>
  <zen-one 
  :showuserinfo="false" 
  title=""
  :crumbs="crumbs"
  >
  <z-page
  title="Bahan Terbitan & eBorang"
  >

  <w-dialog
    v-model="dialog1.show"
    :fullscreen="dialog1.fullscreen"
    :width="dialog1.width"
    :persistent="dialog1.persistent"
    :persistent-no-animation="dialog1.persistentNoAnimation"
    title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      {{dialog.title}}
    </template>

    <w-form 
      ref="form" 
      v-model="dialog1.valid"
      @validate="save"
      @success="success"
    >
    <z-input label="Tajuk" v-model="form.tajuk"  />
    <w-textarea label="Pautan" v-model="form.pautan"  />
    <!-- <w-input type="file" :preview="false" 
  accept=".pdf,application/pdf" v-model="files" multiple>Pautan *</w-input> -->
    <z-input label="Keterangan" v-model="form.keterangan" name="Keterangan" :validators="[validators.required]" />
    <br>
    <w-radios class="mr2" v-model="form.jenis" :items="jenis_list" inline color="blue-light1"></w-radios>
    <br>
    <br>
    <template v-if="form.id != 0">
    <z-select :items="lkp_status" label="Status *"  v-model="form.lkp_status_id"  :validators="[validators.required]"/>
    <z-input label="Susunan" v-model="form.seq" name="Seq" :validators="[validators.required]" />
    </template>
    </w-form>
        

    
    <template #actions>
      <div class="spacer" />
      <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog1.show = false">TUTUP</w-button>
      <w-button 
      class="ml1" 
      :loading="dialog1.loading"
      :disabled="dialog1.valid === false"
      @click="$refs.form.validate()"
      >
        SIMPAN
      </w-button>
    </template>

    
  </w-dialog>
  

  <z-table
    ref="tbluser"
    title="Bahan Terbitan & eBorang"
    :headers="table.headers"  
    :items="table.items"
    :meta="table.meta"
    class=""
  >


 
  <template #button>
        <w-button dark class="green--bg ml1" @click="add()">
            <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
        </w-button>
    </template>
   
  
    <template #header-label="{ header, label, index }">
      <template v-if="header.key == 'action'">
      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
      Tindakan
      </template>
      <template v-else>
      {{ label }}
      </template>
    
    </template>
    <template #item-cell.pautan="{ item, label, header, index }">
        <w-flex class="flex justify-left" style="max-width: 300px;">
          <a 
            :href="item.pautan" 
            style="
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            "
            :title="item.pautan"
          >
            {{ item.pautan }}
          </a>
        </w-flex>
      </template>

    <template #item-cell.action="{ item, label, header, index }">
      <w-flex class="flex justify-center">
        <w-button class="fs-2 pr3 bs" bg-color="orange-light3" tile @click="edit(item)">
          <w-icon xs class="mr2">fal fa-pencil</w-icon> KEMASKINI

        </w-button>
        &nbsp;  
        <w-button class="fs-2" bg-color="red-light1" dark tile @click="destroy(item)">
          <w-icon xs class="mr2"> fal fa-trash</w-icon>PADAM
        </w-button>
       &nbsp;
       
        
      </w-flex>
    </template>

  </z-table>

  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'administration.bahan_terbitan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/' },
        { label: 'Pentadbiran', route: '/administration' },
        { label: 'Bahan Terbitan & eBorang', route: '/administration/bahan_terbitan' }
      ],
      
      form: {
        id: 0,
        tajuk: '',
        pautan: '',
        lkp_status_id :'',
        keterangan:'',
        jenis:'',
        seq:'',
      },
      files: [],
      lkp_status: [],
      jenis_list:[
        {value: 1, label: "Bahan Terbitan"},
        {value: 2, label: "eBorang"},
      ],
      dialog1: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 1200,
          item: {name: '', email: '', mobile: ''}
        },
      validators: {
        required: value => !!value || 'Wajib Isi.',
        
      },
    }
  },
  methods: {
   getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_pengumuman', {}).then(res => {
        this.lkp_status = res
      })
    },
    add(){
          this.form = {
              id : 0,
              tajuk : null,
              pautan : null,
              lkp_status_id : '',
              keterangan:'',
              jenis:'',
              seq:'',
          }
          this.getStatus();
          this.dialog1.show = true
          this.dialog.title = 'TAMBAH'
          this.form.saveButton = "Save"
      },
      save() {
      // if (this.$refs.form.validate()) {
          this.dialog1.loading = true

          if (this.form.id > 0) {
              this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                  .then(res => {
                      //update displayed record
                     if(this.files.length > 0){
                      this.uploadImg(this.form.id);
                     }
                      this.mapreturneddata(res)
                      this.dialog1.show = false;
                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }
                      this.$inertia.visit(this.$page.url)
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                      this.dialog1.loading = false
                      // this.dialog.show = false

                  });
          }
          else {
              this.$zcomm.add(this.resourceurl + '.store', this.form)
                  .then(res => {
                    // console.log(res)
                    //update displayed record
                    // this.$page.flash.success = "Rekod telah ditambah"
                    this.mapreturneddata(res)
                     if(this.files.length > 0){
                        this.uploadImg(res.id);
                     }
                    this.dialog1.show = false;
                    if (typeof this.onAfterAdd === "function") {
                      this.onAfterAdd()
                    }
                    if(this.reload) {
                      this.$inertia.visit(this.$page.url)
                    }
                    this.$inertia.visit(this.$page.url)
                  })
                  .finally(() => {
                      this.dialog1.loading = false;

                    // $('#' + this.resourceurl).modal('hide')
                  });
          }
      // }
        },
        uploadImg(item) 
        {  
           let formData = new FormData();
           for (var b in this.files) 
           {
               formData.append("files["+b+"]", this.files[b].file);
           }
           formData.append("model",'App\\Models\\BahanTerbitan');
           formData.append("model_id", item);
           this.$zcomm.post('attahecment.upload_replace', formData)
               .then((res) => {
                   this.getAttahecment();
               })
               .catch((err) => {})
               .finally(() => {});
       },
      edit(form){
          this.form = form
          this.dialog1.show = true
          this.getStatus();
          this.dialog.title = 'KEMASKINI'
          this.form.saveButton = "Save"
      }

  },

  watch: {

  },
  mounted() {
    // override default setting
    this.dialog.width = 500
  
      
  },
}
</script>
